import {Get, Post} from "@kkmh/utils";
/**
 * getVerifyConfig 获取滑动验证码配置    Get: /v1/fraud/verify/config
 * @author: zhilichao
 * 接口文档: https://yapi.quickcan.com/project/1123/interface/api/50398
 * 对接后端: 陈凯_1(用户)
 * @param callback   全局上的函数名称, 用来接收服务端返回的数据,初始化滑动验证码   必填参数
 * @param channel   渠道枚举: mini:小程序  web: 网页及app       必填参数
 * @param scene_type  验证码使用的场景，默认other account:账号场景,sms:短信场景,activity:活动场景,other:其他 非必须
 * 
 * return Promise
 * **/
function getVerifyConfig({callback="", channel="web", scene_type="sms"}={}){
    return Get({
        url: "/v1/fraud/verify/config",
        data:{callback, channel, scene_type}
    });
}

/**
 * ** postSmsSendCode 建站模块 短信验证码接口   Post: /v2/passport/open/sms/send_code
 * @author:zhilichao
 * 接口文档: https://yapi.quickcan.com/project/66/interface/api/53014
 * 对接后端: 陈凯_1(用户)
 * @Headers
 * Content-Type: application/x-www-form-urlencoded
 * Product-Line: pay
 * 
 * @param phone  接收短信的手机号  必须参数
 * @param reason 短信验证码枚举内容 必须参数 默认值: ad_activity
 * @param verify_provider 验证码提供方   非必须 
 * @param ticket 腾讯验证码参数   非必须
 * @param random 腾讯验证码参数   非必须
 * **/
function postSmsSendCode({phone=0, reason="pay_bind", verify_provider="", ticket="", random=""}={}){
    let data = {phone, reason};
    if(verify_provider && ticket){
        data.verify_provider = verify_provider;
    }
    if(ticket){
        data.ticket = ticket;
    }
    if(random){
        data.random = random;
    }

    return Post({
        url: "/v2/passport/open/sms/send_code",
        data,
        headers:{
            "Content-Type": "application/x-www-form-urlencoded",
            "Product-Line": "pay"
        }
    });
}

/**
 * ** postBindAccount 绑定通用联合会员账号  Post: /v1/vip/link_account/bind_account
 * @author:zhilichao
 * 接口文档: https://yapi.quickcan.com/project/341/interface/api/58016
 * 对接后端: 冬冬(付费)
 * @Headers
 * Content-Type: application/x-www-form-urlencoded
 * 
 * @param assign_account_type {str/num}  0:仅手机号(绑定/变更) 1:混搭(qq/手机号绑定) 2:仅QQ号(绑定/变更)
 * @param code {str/num} 手机验证码[仅手机号 / 混搭需要] 
 * @param phone_account {str/num} 手机号[仅手机号 / 混搭需要]
 * @param qq_account {str/num} qq号[混搭 / 仅QQ号需要]
 * @param confirm_qq_account {str/num} 确认的手机号 [仅QQ号需要]
 * @param activity_name {str} 活动标识
 * @param award_name {str} 奖励标识
 * **/
function postBindAccount({
    assign_account_type = 0, 
    code = "" , 
    phone_account= "", 
    qq_account = "",
    confirm_qq_account = "",
    activity_name = "",
    award_name = ""
} = {}){
    let data = {
        assign_account_type,
        activity_name,
        award_name
    };
    if(assign_account_type==0 || assign_account_type==1) {
        data.phone_account = phone_account;
        data.code = code;
    }
    if(assign_account_type==1 || assign_account_type==2) {
        data.qq_account = qq_account;
    }
    if(assign_account_type==2) {
        data.confirm_qq_account = confirm_qq_account;
    }
    return Post({
        url: "/v1/vip/link_account/bind_account",
        data,
        headers:{
            "Content-Type": "application/x-www-form-urlencoded"
        }
    });
}

/**
 * ** getAccount 查询绑定的通用联合会员账号  Get: /v1/vip/link_account/get_account
 * @author:zhilichao
 * 接口文档: https://yapi.quickcan.com/project/341/interface/api/58070
 * 对接后端: 冬冬(付费)
 * @Headers
 * Content-Type: application/x-www-form-urlencoded
 * **/
function getAccount(){
    return Get({
        url: "/v1/vip/link_account/get_account",
        data: {}
    });
}


/**
 * bindPhoneOut 端外绑定手机号    Post: /v1/vip/link_vip/bind_phone
 * @author: gqy
 * 接口文档: https://yapi.quickcan.com/project/341/interface/api/37506
 * 对接后端: 冬冬
 * @param phone   手机号   必填参数
 * @param code   验证码       必填参数
 * @param activity_name  活动名称   必填参数
 * 
 * return Promise
 * **/
function bindPhoneOut({phone="", code="", activity_name="", request_from=0}={}){
    let data = {phone, code, activity_name, request_from};
    return Post({
        url: "/v1/vip/link_vip/bind_phone",
        data,
        headers:{
            "Content-Type": "application/x-www-form-urlencoded"
        }
    });
}

export {
    getVerifyConfig,
    postSmsSendCode,
    postBindAccount, // 绑定通用联合会员账号
    getAccount, // 查询绑定的通用联合会员账号
    bindPhoneOut, // 端外绑定手机号
};


// WEBPACK FOOTER //
// ./src/pages/native/pay/vip/link_vip_multiple/api/verify.api.js